import React from "react"

export default function Cheers({children}){
    const [modalStyle, setModalStyle] = React.useState({display: 'inline'})

    function toggleDisplayStyle(){
        setModalStyle({display: 'none'})
    }

    return (
        <div id='modal'style={modalStyle} className="modal">
            <div className="close-modal-btn-container">
                <button onClick={toggleDisplayStyle} className="modal-close-btn">Close ❌❎</button>
            </div>
            <div className="modal-inner">
                {children}
            </div>
        </div>
    )
}